import React, { useCallback, useEffect, useMemo, useState } from 'react';
import './styles.css';
import { useLocation } from 'react-router';
import ContractBarcode from '../../../components/ContractBarcode';
import { resolveContractBarcode } from '../../../helpers/contract-barcode';
import ContractsService from '../../../services/constracts.service';

const CREDIT_LINE_PENDING_STATUS = 1;
const CREDIT_LINE_APPROVED_STATUS = 2;

const ContractCredit = props => {
  const location = useLocation();
  const { application, financingPartner } = location.state || {};
  const today = new Date();
  const barcodeValue = useMemo(
    () => resolveContractBarcode(application, financingPartner),
    [application, financingPartner],
  );
  const [isLogoLoaded, setIsLogoLoaded] = useState(false);
  const [isBarcodeRendered, setIsBarcodeRendered] = useState(!barcodeValue);

  const handleLogoLoad = useCallback(() => {
    setIsLogoLoaded(true);
  }, []);

  const handleLogoError = useCallback(() => {
    setIsLogoLoaded(true);
  }, []);

  const handleBarcodeRendered = useCallback(() => {
    setIsBarcodeRendered(true);
  }, []);

  useEffect(() => {
    if (!application?.userId || !isLogoLoaded || !isBarcodeRendered) {
      return;
    }

    ContractsService.auditCreditContract(application.userId);
    window.print();
  }, [application?.userId, isLogoLoaded, isBarcodeRendered]);

  if (!application) {
    return (
      <div className="contract-body body" style={{ padding: '24px' }}>
        Contract data is missing. Open this page from the CMT contracts list.
      </div>
    );
  }

  return (
    <>
      <div className="contract-body body" dir="rtl">
        <div className="contract-header">
          <div className="contract-header__logo">
            <img
              src="https://cx-admin.thelucky.io/img/Lucky-logo-full.39484ca1.svg"
              alt="Lucky One"
              onLoad={handleLogoLoad}
              onError={handleLogoError}
            />
          </div>
          {barcodeValue ? (
            <ContractBarcode
              value={barcodeValue}
              onRendered={handleBarcodeRendered}
            />
          ) : null}
        </div>

        <h1 className="text-center underline" style={{ marginTop: '12px' }}>
          عقد تقديم خدمات
        </h1>

        <p style={{ marginTop: '10px', marginRight: '20px' }}>
           أبرم هذا العقد في يوم{' '}
          <span className="underlineDottedLight" style={{ minWidth: '140px' }} />
          &nbsp;الموافق{' '}
          <span className="underlineDottedLight" style={{ minWidth: '140px' }} />
          &nbsp;<b>("العقد"){' '}</b> بين كلاً من:
        </p>

        <ol className="terms-list">
          <li><b>
            شركة الكي مصر للبرمجيات ش.م.م،</b> سجل تجاري رقم{' '}
            <span><b>
              156882
            </b></span>
            ، والكائن مقرها الرئيسي في بلوك إتش، مول العرب، 6 أكتوبر، الجيزة،
            جمهورية مصر العربية <span style={{ textAlign: 'left'}}>(ويشار إليها فيما بعد <b>"الطرف الأول"</b>أو <b>"الشركة"</b>).</span>
          </li>
          <li>
            <p>
              السيد/ة{' '}
              <span className="underlineDottedLight" style={{ minWidth: '260px' }}>
                {application.firstName} {application.secondName}{' '}
                {application.thirdName} {application.familyName}
              </span>
              &nbsp;رقم الهاتف/
              <span className="underlineDottedLight" style={{ minWidth: '180px' }}>
                {application.phone}
              </span>
            </p>
            <p>
              بطاقة رقم قومي{' '}
              {application.documentNumber
                ? application.documentNumber
                    .slice(0, 14)
                    .split('')
                    .reverse()
                    .map((digit, index) => (
                      <span key={index} className="square">
                        {digit}
                      </span>
                    ))
                : Array.from({ length: 14 }).map((_, index) => (
                    <span key={index} className="square" />
                  ))}
            </p>
            <p>
           والمقيم بشارع،
              <span className="underlineDottedLight width100">
                {application.street}
              </span>
              &nbsp;منطقة،
              <span className="underlineDottedLight width100">
                {application.disctrict}
              </span>
              &nbsp;محافظة،
              <span className="underlineDottedLight width100">
              </span>
              &nbsp;عمارة رقم،
              <span className="underlineDottedLight width50">
                {application.buildingNumber}
              </span>
              &nbsp;الدور،
              <span className="underlineDottedLight width50" />
              &nbsp;شقة رقم،
              <span className="underlineDottedLight width50">
                {application.floorFlatNumber}
              </span>
            </p>
            <p>
              علامة مميزة،
              <span className="underlineDottedLight" style={{ minWidth: '260px' }} />
              &nbsp;تليفون أرضي
              <span className="underlineDottedLight width80" />
            </p>
          </li>
            (ويشار إليها فيما بعد بـ  <b>"الطرف الثاني" </b>أو<b> "العميل"</b>، ويشار إليهما فيما
            بعد مجتمعين بـ "الطرفين" ومنفردين بـ "الطرف").
        
        </ol>

        <h3 className="text-center" style={{ marginTop: '5px', marginBottom: '0px' }}>
           التمهيد
        </h3>
        <ol className="terms-list">
          <li>حيث إن الشركة تمتلك وتدير تطبيق لاكي <b>("التطبيق") </b>وتُقِّدم لعملائها مجموعة من الخدمات،تشمل على سبيل المثال لا الحصر، خدمات الولاء والخصومات غير المحدودة والكاش باك، التحويل بين بطاقات لاكي وشحن البطاقة عبر إنستاباي،   
وتمكين العميل من تتبع جميع معاملاته من خلال التطبيق، وخدمات البيع بالتقسيط للمنتجات التي تتيحها التجار للعملاء في محاًلهم التجارية بمختلف أنواعها و/أوعلى الموقع الالكتروني والتي تتيح للعميل إمكانية شراء المنتجات من التجار وسداد   
قيمتها على أقساط تصل إلى ٥ دفعات وفقاً لما يتم أتاحته على التطبيق  <b>"القسط الشهري"</b> ، حيث تحدد الشركةمن حين آلخر مبلغ معين وفقًالتقديرها المنفرد )<b>"الحد األقصى للمشتريات "</b>(، ويتم إضافته الي حساب العميل من خلال الطرق   
المتاحة علي التطبيق بما في ذلك ال بطاقة مسبقة الدفع التي يتم تشغيلها من قبل الشركة )<b>"بطاقة الكي"</b>( الخاصة بالعميل ليستخدمه لشراء المنتجات من التجار)<b>"الخدمات "</b> 
            </li>
            <li> وحيث إن العميل يرغب في الاشتراك فيبعض الخدمات المشار إليها أعاله وفقاً لقواعد وشروط هذاالعقد وسياسات الشركة الموضحة على التطبيق وعلى الموقع اإللكتروني للشركة 
              <a href="https://app.thelucky.io/" target="_blank" rel="noreferrer" style={{ textDecoration: 'underline' }}> https://app.thelucky.io/ </a>
            </li>
            <li> عليه،وبناًءعلى التمهيد والتعهدات الواردة في هذاالعقد،اتفق الطرفان بعد أن أقرا بكامل أهليتهما القانونية للتصرف و التعاقد على ما يلي:
            </li>
        </ol>

        <h3 className="text-center" style={{ marginTop: '5px', marginBottom: '0px' }}>
          (1) التمهيد
        </h3>
        <p>
        يعد التمهيد السابق والمالحق جزا ال يتجزأ من هذا العقد ومتمما لبنوده وأحكامه.   
        </p>

        <h3 className="text-center" style={{ marginTop: '5px', marginBottom: '0px' }}> (2) موضوع العقد وتقديم خدمات الشركة</h3>
        <ol className="terms-list">
          <li>
            يقر العميل بأنه يمتلك تطبيق لكي ("التطبيق")، وتقدم الشركة من خلال
            التطبيق مجموعة من الخدمات التي تتضمن على سبيل المثال لا الحصر خدمات
            الدفع والتحويل بين المحافظ وإصدار القسائم الشرائية وعروض الاسترداد
            النقدي وخدمات التقسيط.
          </li>
          <li>
            يقر العميل بأنه اطلع ووافق على كافة الشروط والأحكام العامة والخاصة
            بالخدمات المتاحة من خلال التطبيق، والمنشورة على الموقع الإلكتروني
            للشركة{' '}
            <a
              href="https://thelucky.app/pages/terms.html"
              target="_blank"
              rel="noreferrer"
            >
              https://thelucky.app/pages/terms.html
            </a>
            ، وسياسة الخصوصية المنشورة على الرابط{' '}
            <a
              href="https://thelucky.app/pages/policy.html"
              target="_blank"
              rel="noreferrer"
            >
              https://thelucky.app/pages/policy.html
            </a>
            ، ويعتبر توقيع العميل على هذا العقد قبولاً نهائياً لها.
          </li>
          <li>
            يقر العميل بأن استخدامه للتطبيق والخدمات يكون فقط من خلال حسابه
            الشخصي، وأنه المسؤول وحده عن جميع التعاملات والعمليات التي تتم من
            خلال حسابه والتطبيق.
          </li>
        </ol>

        <h3 className="text-center" style={{ marginTop: '5px', marginBottom: '0px' }}> (3) شروط السداد والتزامات العميل   
</h3>
        <ol className="terms-list">
          <li>
            يلتزم العميل باستيفاء كافة البيانات التي تطلبها الشركة من وقت لآخر، مع
            الإقرار بصحة البيانات المقدمة.
          </li>
          <li>
            يلتزم العميل بتأكيد كل عملية شراء على حدة من خلال التطبيق، والذي يجب أن
            يتضمن سعر الشراء ومواعيد الأقساط المستحقة، بالإضافة إلى أي رسوم أو
            تكاليف أخرى قد تكون مستحقة للشركة.
          </li>
          <li>
            يلتزم العميل بسداد القسط الشهري في المواعيد المحددة دون تأخير، عن طريق
            وسائل الدفع المقبولة من قبل الشركة.
          </li>
          <li>
            يلتزم العميل بإخطار الشركة في حالة تغيير محل إقامته بموجب إخطار كتابي
            مسبق لا تقل مدته عن سبعة (7) أيام.
          </li>
          <li>
            اتفق الطرفان على أنه في حالة إخلال العميل في سداد القسط الشهري في
            الآجال المحددة على التطبيق، يحق للشركة فرض غرامة تأخير من قيمة القسط
            المتأخر الموضحة على التطبيق، وتطبَّق بدون إنذار أو إعذار أو حكم قضائي
            بمجرد التأخير.
          </li>
          <li>
            يقر العميل أنه قد عاين المنتجات المبيعة معاينة تامة نافية للجهالة،
            ويتحمل مسؤولية أي هلاك لها، ومن ثم ليس له الحق في الرجوع على الشركة.
          </li>
          <li>
            يحق للعميل طلب تعجيل الوفاء بكل الأقساط الشهرية وفقاً لما سيتم تحديده
            على التطبيق.
          </li>
          <li>
            يقر العميل بحق الشركة في تعليق حساب العميل في حالة انتهاء سريان إثبات
            هويته (بطاقة رقم قومي) لحين إرسال ما يثبت تجديد إثبات هويته.
          </li>
          <li>
            يقر العميل بأنه قد اطلع على الشروط والأحكام الخاصة بالتطبيق والمتوفرة
            على الرابط التالي{' '}
            <a
              href="html.terms/pages/app.thelucky://https"
              target="_blank"
              rel="noreferrer"
            >
              html.terms/pages/app.thelucky://https
            </a>{' '}
            والتي تعد جزءاً لا يتجزأ من هذا العقد، وفقاً لما يتم تعديلها من وقت
            لآخر.
          </li>
          <li>
            يلتزم العميل بإبلاغ الشركة فور ضياع أو سرقة بطاقة الكي أو الهاتف
            المحمول المسجل عليه التطبيق أو رقم الهاتف، ويكون ملتزماً بسداد أي
            معاملة تتم خلال فترة فقدانه وحتى إبلاغ الشركة، وذلك دون الإخلال بحق
            الشركة في المطالبة بتوقيع العقوبات المقررة قانوناً ولحين تحصيل إجمالي
            الأقساط الشهرية.
          </li>
          <li>
            يقر العميل ويوافق صراحةً بأن الحد الأقصى للمشتريات، وكذلك قيمة الأقساط
            الشهرية على النحو الذي تحدده الشركة والمبيَّنة من خلال التطبيق، أو التي
            يتم إخطار العميل بها عن طريق رسالة نصية، يعتبر حجة قاطعة في مواجهة
            العميل بما يكفل للشركة الحق في الاستناد إلى تلك البيانات وإثباتها أمام
            الجهات القضائية المختصة، دون أي اعتراض أو طعن من جانب العميل.
          </li>
          <li>
            يُقر العميل ويتعهد بموجب هذا العقد بتفويض الشركة بالخصم المباشر من
            حسابه البنكي المرتبط ببطاقة الكي، في حالة وجود أي مبالغ مستحقة للشركة
            بموجب هذا العقد، ويُعد هذا التفويض سارياً طوال مدة العقد ما لم يتم سداد
            تلك المبالغ خلال هذه المدة.
          </li>
        </ol>

        <h3 className="text-center" style={{ marginTop: '5px', marginBottom: '0px' }}>
          (4)  المدة والإنتهاء  
        </h3>
        <ol className="terms-list">
          <li>
            يسري هذا العقد من تاريخ التوقيع، ويُجدَّد هذا العقد بصورة تلقائية لمدة
            أو مدد مماثلة ("المدة المجددة") ما لم يُخطر أحد الطرفين الطرف الآخر برغبته
            بعدم التجديد قبل نهاية المدة الأولية أو المدة المجددة (وفقاً لما يقتضيه
            الحال) بموجب إخطار كتابي مسبق بشهرين (2).
          </li>
          <li>
            يحق للشركة إنهاء هذا العقد فوراً بدون الحاجة إلى إعذار أو إنذار أو اتخاذ
            أي إجراء قانوني آخر في حالة إخلال العميل بأي من التزاماته المنصوص عليها
            بهذا العقد، بما في ذلك الإخلال - على سبيل المثال لا الحصر - بسداد أي من
            الأقساط الشهرية وعدم تصحيح إخلاله بسداد الأقساط الشهرية من خلال طرق
            السداد المتاحة على التطبيق بحد أقصى يوم واحد من تاريخ استحقاقها، وذلك
            دون إعذار، ودون الحاجة لسداد أي تعويضات للعميل، مع عدم الإخلال بحقوق
            الشركة القانونية المنصوص عليها بهذا العقد.
          </li>
          <li>
            لا يخل ما سبق بحق أي طرف في الرجوع على الطرف الآخر حال الإنهاء بسبب
            إخلال الأخير بالتزاماته التعاقدية بالتعويض الجابر للأضرار التي لحقت
            بالطرف غير المخل نتيجة هذا الإخلال.
          </li>
        </ol>

        <h3 className="text-center" style={{ marginTop: '5px', marginBottom: '0px' }}> (5) السرية</h3>
        <ol className="terms-list">
          <li>
            يلتزم الطرفان بعدم الإفصاح عن أي من المعلومات السرية، بطريقة مباشرة أو
            غير مباشرة، خاصة بالطرف الآخر، أو شركاته التابعة، أو الشقيقة، أو أطرافه
            المرتبطة إلى أي شخص غير مصرح له بالاطلاع على تلك المعلومات السرية، وتكون
            كافة المعلومات المفصح عنها للشركة خاضعة لسياسة الخصوصية الخاصة بالشركة
            والمتوفرة على الرابط التالي{' '}
            <a
              href="https://thelucky.app/pages/policy.html"
              target="_blank"
              rel="noreferrer"
            >
              https://thelucky.app/pages/policy.html
            </a>
            .
            يوافق العميل على أن تقوم الشركة بمعالجة بياناته واستخدامها ومشاركتها مع
            شركائها ومقدمي الخدمات وشركات الاستعلام الائتماني والجهات الرقابية
            المختصة، وذلك في الحدود اللازمة لتقديم الخدمات محل هذا العقد.
          </li>
        </ol>

        <h3 className="text-center" style={{ marginTop: '5px', marginBottom: '0px' }}>
          (6) أحكام عامة
        </h3>
        <ol className="terms-list">
          <li>
            يخضع هذا العقد ويفسر وفقاً لأحكام قوانين جمهورية مصر العربية، وتختص محاكم
            جمهورية مصر العربية بكافة درجاتها بالفصل في أي نزاع أو خلاف أو مطالبة
            نابعة عن هذا العقد.
          </li>
          <li>
            لا يحق للعميل حوالة هذا العقد أو التنازل عن أي من حقوقه أو التزاماته إلا
            بعد الموافقة الكتابية المسبقة للشركة، ويحق للطرف الأول حوالة أو التنازل
            عن أي من حقوقها أو التزاماتها المنصوص عليها بهذا العقد بموجب إخطار مسبق
            يرسل للعميل.
          </li>
          <li>
            يقوم العميل بشراء المنتجات نيابةً عن الشركة وتحتفظ الشركة بحق ملكية
            المنتجات المباعة باستخدام الحد الأقصى للمشتريات حتى استيفاء كامل الثمن من
            العميل وسداد كامل الأقساط، فإذا تأخر العميل في سداد ما عليه من أقساط بما
            يعادل أقل من %75 من كامل الثمن، يحق للشركة فسخ التعاقد واسترداد المنتجات
            ورد المبالغ المدفوعة بعد خصم قيمة استعمال المنتجات حتى تاريخ الفسخ ومبلغ
            تعويض اتفاقي.
          </li>
          <li>
            يقر العميل بأنه استلم المنتجات محل هذا العقد على سبيل الأمانة لحين سداد
            كامل الثمن، ولا يجوز له التصرف فيها أو تسليم حيازة المنتجات المشتراة
            نيابةً عن الشركة بأي نوع من التصرفات قبل وفائه بكامل الثمن، ولا يجوز أن
            يَسري أي تعديل على العقد ما لم يكن كتابة ويوقع من قبل الطرفين.
          </li>
          <li>
            إن إخفاق أي طرف من الأطراف في ممارسة أو تنفيذ أي حق من الحقوق الممنوحة
            له بموجب هذا العقد لا يعتبر تنازلاً منه عن ذلك الحق أو يكون بمثابة مانعاً
            يحول دون ممارسته أو تنفيذه في أي حين أو أحيان أخرى فيما بعد.
          </li>
          <li>
            يجب أن يتم إرسال الإخطارات المتعلقة بهذا العقد كتابةً، بما في ذلك على
            سبيل المثال بالبريد المسجل أو تسلُّمها باليد مع التوقيع بالاستلام من
            الطرف المستلِم، أو بالبريد الإلكتروني، أو التطبيق، أو الرسائل النصية.
          </li>
          <li>
            يقر العميل بالاعتداد بكافة المراسلات والمخاطبات المرسلة له من قبل الشركة
            على البيانات المبينة في صدر هذا العقد أو الواردة في الملحق رقم (1) من هذا
            العقد.
          </li>
          <li>
            وتكون لكافة المراسلات الإلكترونية والتطبيق حجية قبل العميل لا يجوز الطعن
            عليها أو جحدها استناداً إلى ما أرسته محكمة النقض المصرية في الإثبات عن
            طريق البريد الإلكتروني وعدم إمكانية جحده.
          </li>
          <li>
            استثناءً من أحكام البند 6-8، تكون كافة الإخطارات الخاصة بالتقاضي أو
            الإخطارات القانونية بما في ذلك الإخلال والفسخ والتعويض وفقاً لما هو
            منصوص عليه بقانون المرافعات ولا يعتد بأي صور أخرى من صور الإخطارات
            والإعذار، وذلك ما لم ينص هذا العقد على خلاف ذلك صراحةً.
          </li>
        </ol>

        <div className="page-break"></div>
        {/* الصفحة الخاصة بالتوقيعات والبيانات الإضافية */}
        <h3 className="text-center" style={{ marginTop: '15px', marginBottom: '5px' }}>
          (7) نسخ العقد
        </h3>

        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '16px' }}>
          <div style={{ width: '50%' }}>
            <p style={{ fontWeight: 'bold' }}>الطرف الأول: شركة لكي مصر للبرمجيات ش.م.م</p>
            <p>
              الاسم:{' '}
              <span className="underlineDottedLight" style={{ minWidth: '240px' }} />
            </p>
            <p>
              الصفة:{' '}
              <span className="underlineDottedLight" style={{ minWidth: '240px' }} />
            </p>
            <p>
              التوقيع:{' '}
              <span className="underlineDottedLight" style={{ minWidth: '240px' }} />
            </p>
            <p>
              التاريخ:{' '}
              <span className="underlineDottedLight" style={{ minWidth: '160px' }} />
            </p>
          </div>

          <div style={{ width: '50%' }}>
            <p style={{ fontWeight: 'bold' }}>الطرف الثاني: العميل</p>
            <p>
              الاسم:{' '}
              <span className="underlineDottedLight" style={{ minWidth: '240px' }}>
                {application.firstName} {application.secondName}{' '}
                {application.thirdName} {application.familyName}
              </span>
            </p>
            <p>
              التوقيع:{' '}
              <span className="underlineDottedLight" style={{ minWidth: '240px' }} />
            </p>
            <p>
              التاريخ:{' '}
              <span className="underlineDottedLight" style={{ minWidth: '160px' }} />
            </p>
          </div>
        </div>

        {/* الملحق رقم (1) */}
        <h3 className="text-center" style={{ marginTop: '5px', marginBottom: '0px' }}>
          الملحق رقم (1)
        </h3>

        <div style={{ marginRight: '40px', marginLeft: '40px' }}>
          <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>
            1.&nbsp;&nbsp;بيانات الوظيفة الحالية
          </p>

          <p style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
            الوظيفة الحالية:
          </p>

          <p>
            اسم الشركة:
            <span className="underlineDottedLight width100" />
            رقم هاتف العمل:
            <span className="underlineDottedLight width100" />
          </p>

          <p>
            عنوان العمل:
            <span className="underlineDottedLight" style={{ minWidth: '400px' }} />
          </p>

          <p>
            مدة العمل:
            <span className="underlineDottedLight width80" />
            الدخل:
            <span className="underlineDottedLight width80" />
            مصادر دخل أخرى:
            <span className="underlineDottedLight width350" />
          </p>
        </div>
      </div>
    </>
  );
};

export default ContractCredit;
